import React, { useContext } from "react";
import AppContext from "../../store/app-context";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import styles from "./button-circle.module.css";

const ButtonCircle = () => {
  const appCtx = useContext(AppContext);

  return (
    <>
      <button className={styles.button} onClick={appCtx.handlePrevStep}>
        <ChevronLeftIcon />
      </button>
    </>
  );
};

export default ButtonCircle;
